// extracted by mini-css-extract-plugin
export var button = "_40-7";
export var buttonRow = "_40-6";
export var fadeIn = "_40-1";
export var gradient = "_40-0";
export var panel = "_40-2";
export var panelIn = "_40-3";
export var subtitle = "_40-5";
export var title = "_40-4";